import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import Dashboard from "../jutge/Dashboard";
import Problemes from "../jutge/problemes/Problemes";
import ProblemesId from "../jutge/problemesId/ProblemesId";
import Activitats from "../jutge/problemes/content/Activitats";
import ActivitatsId from "../jutge/activitatsId/ActivitatsId";
import AlumnesId from "../jutge/activitatsIdAlumnesId/AlumnesId";
import Practiques from "../jutge/problemes/content/Practiques";
import PracticaId from "../jutge/practiquesId/PracticaId";
import Notes from "../jutge/problemes/content/Notes";
import Ranking from "../jutge/problemes/content/Ranking";
import Caza from "../jutge/problemes/content/Caza";
import Pildores from "../jutge/problemes/content/Pildores";
import PildoresId from "../jutge/pildoresId/PildoresId";

import { IdePage } from "../jutge/ide/IdePage";
import { IdeAdminDashboard } from "../jutge/ide/IdeAdminDashboard";
import { IdeTelemetryDashboard } from "../jutge/ide/IdeTelemetryDashboard";
import ConfiguracioJavamons from "../jutge/ConfiguracioJavamons";

import { useContext } from "react";
import { AuthContext } from "../../config/AuthContext";

const AppJutgeRoutes = () => {
    const { user, alumne } = useContext(AuthContext);
    const isRole3 = String(user?.tipus) === "3";

    const userAulas = alumne?.aules || [];
    const isExamMode = user?.tipus === "2" && (userAulas || []).some((a: any) =>
        Boolean(a.isExamen === 1 || a.isExamen === true || a.is_examen === 1 || a.is_examen === true)
    );

    return (
        <Routes>
            <Route path="/" element={
                isExamMode ? <Navigate to="/jutge/examens" replace /> : (isRole3 ? <Navigate to="/jutge/problemes" replace /> : <Dashboard />)
            } />
            <Route path="/problemes" element={<Problemes />} />
            <Route path="/activitats" element={<Activitats />} />
            <Route path="/practiques" element={<Practiques />} />
            <Route path="/examens" element={<Practiques onlyExams={true} />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/ranking" element={<Ranking />} />
            <Route path="/caza" element={<Caza />} />
            <Route path="/pildores" element={<Pildores />} />
            <Route path="/pildores/:id_conjunt" element={<PildoresId page={0} />} />
            <Route path="/pildores/:id_conjunt/estadistiques" element={<PildoresId page={1} />} />
            <Route path="/ide" element={<IdePage />} />
            <Route path="/ide/admin" element={<IdeAdminDashboard />} />
            <Route path="/ide/telemetry" element={<IdeTelemetryDashboard />} />
            <Route path="/javamon/config" element={<ConfiguracioJavamons />} />
            <Route path="/javamon/config/:tab" element={<ConfiguracioJavamons />} />
            <Route path="/practiques/:id_practica" element={<PracticaId />} />
            <Route path="/problemes/:id_problema" element={<ProblemesId />} />
            <Route path="/activitats/:id_activitat" element={<ActivitatsId page={0} />} />
            <Route path="/activitats/:id_activitat/alumnes" element={<ActivitatsId page={1} />} />
            <Route path="/activitats/:id_activitat/problemes/:id_problema" element={<ProblemesId />} />
            <Route path="/activitats/:id_activitat/alumnes/:id_alumne" element={<AlumnesId />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default AppJutgeRoutes;